module.exports = __webpack_public_path__ + "static/media/soccer-banner.e95a6037.png";